import * as React from 'react';
import * as styled from './styled';
import {useFormikContext} from 'formik';
import {IngredientObject} from 'api/ingredient/types';
import {RecipeIngredient, RecipeObject} from 'api/recipe/types';
import {SelectIngredient} from 'components/SelectIngredient';
import {TotalEnergy} from 'components/TotalEnergy';
import {Ingredient} from './components/Ingredient';

/**
 * The content of a recipe builder.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Content(): React.ReactElement {
  const {values, setFieldValue} = useFormikContext<Partial<RecipeObject>>();
  const ingredients = values.ingredients || [];

  /**
   * Render total energy.
   * @return {JSX.Element}
   */
  function renderTotalEnergy(): JSX.Element {
    return (
      <styled.Header>
        Ингредиенты
        <TotalEnergy ingredients={ingredients} />
      </styled.Header>
    );
  }

  /**
   * Render ingredients.
   * @return {JSX.Element}
   */
  function renderIngredients(): JSX.Element {
    /**
     * Render the ingredient.
     * @param {RecipeIngredient} ingredient
     * @param {number} index
     * @return {JSX.Element}
     */
    function renderIngredient(
        ingredient: RecipeIngredient,
        index: number,
    ): JSX.Element {
      return (
        <Ingredient
          {...ingredient}
          index={index}
        />
      );
    }

    return (
      <React.Fragment>
        {values.ingredients?.map((ingredient, index) => (
          renderIngredient(ingredient, index)
        ))}
      </React.Fragment>
    );
  }

  /**
   * Render select.
   * @return {JSX.Element}
   */
  function renderSelect(): JSX.Element {
    /**
     * The select event handler.
     * @return {void}
     */
    function handleSelect(ingredient: IngredientObject): void {
      setFieldValue('ingredients', [
        ...ingredients,
        {
          ...ingredient,
          weight: 0,
        },
      ]);
    }

    return (
      <SelectIngredient
        onSelect={handleSelect}
      />
    );
  }

  return (
    <React.Fragment>
      {renderTotalEnergy()}
      {renderIngredients()}
      {renderSelect()}
    </React.Fragment>
  );
}
